import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { NgxPermissionsService } from 'ngx-permissions';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../../../environments/environment';
import { User } from '../../models/users/user';

@Injectable()
export class AuthenticationService {

    public token: string = null;
    public user: User = new User();

    constructor(
        private http: Http,
        private ngxPermissionsService: NgxPermissionsService
    ) {
        console.log();
        // set token if saved in local storage
        let TrackerAuthData = JSON.parse(localStorage.getItem('TrackerAuthData'));
        this.token = !!TrackerAuthData && !!TrackerAuthData.Token ? TrackerAuthData.Token : null;
        console.log('this.token constructor', this.token);
    }

    public login(username: string, password: string): Observable<boolean> {
        let headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');

        let options = new RequestOptions({ headers: headers });

        let params = new URLSearchParams();
        params.append('grant_type', 'password');
        params.append('username', username);
        params.append('password', password);
        params.append('scope', "web");

        console.log('AuthenticationService > login > params', params.toString());
        return this.http.post(environment.backendUri + 'auth/token', params.toString(), options)
            .map((response: Response) => {
                let r = response.json();
                console.log('AuthenticationService > login > r', r);
                if (!response.ok || !r.access_token) {
                    return false;
                }
                localStorage.setItem('TrackerAuthData', JSON.stringify({
                    Token: r.access_token,
                    Id: r.id,
                    UserName: r.userName,
                    FirstName: r.firstName,
                    LastName: r.lastName,
                    DocumentNumber: r.documentNumber,
                    Birthdate: r.birthdate,
                    Photo: r.photo,
                    Email: r.email,
                    EmailConfirmed: r.EmailConfirmed,
                    PhoneNumber: r.phoneNumber,
                    PhoneNumberConfirmed: r.phoneNumberConfirmed,
                    Language: r.language,
                    Roles: JSON.parse(r.roles),
                    UpdatedDate: r.updatedDate,
                    Shifts: JSON.parse(r.shifts),
                    SchoolYear: JSON.parse(r.schoolYear),
                }));
                this.token = r.access_token;

                console.log('this.token ', this.token);


                this.user.UserName = r.userName;
                this.user.Email = r.email;
                this.user.FirstName = r.firstName;
                this.user.LastName = r.lastName;
                this.user.Photo = r.photo;
                this.user.UpdatedDate = !!r.updatedDate ? new Date(r.updatedDate) : null;

                return true;
            }).catch(this.handleError);
    }

    public getAuthData(): any {
        return JSON.parse(localStorage.getItem("TrackerAuthData"));
    }

    public setAuthData(authData: any) {
        localStorage.setItem('TrackerAuthData', JSON.stringify(authData));
    }

    public getPermissions(): string[] {
        let authData = this.getAuthData();
        if (!!authData) {
            let permissions: string[] = [];
            for (const role of authData.Roles) {
                for (const permission of role.Permissions) {
                    if (!permissions.find(p => p === permission)) {
                        permissions.push(permission.Name);
                    }
                }
            }
            return permissions;
        }
        return null;
    }

    public getLanguage(): string {
        let authData = this.getAuthData();
        if (!!authData) {
            return authData.Language;
        }
        return null;
    }

    public getUserId(): string {
        let authData = this.getAuthData();
        if (!!authData) {
            return authData.Id;
        }
        return null;
    }

    public handleError(error: Response) {
        //console.error(error);
        console.log('AuthenticationService > handleError > error', error);
        return Observable.throw(error.json().error || 'Server error');
    }

    public logout(): void {
        // clear token remove user from local storage to log user out
        this.token = null;
        this.ngxPermissionsService.flushPermissions();
        localStorage.removeItem('TrackerAuthData');
        this.user = new User();
    }

}



// WEBPACK FOOTER //
// ./src/app/main/services/authentication/authentication.service.ts